import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import classes from './Account.scss'

import { rolloverOptions } from 'helpers/components'
import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const Account = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Editing Your Account
      </div>

      <div className={classes['header-buttons']}>
        <Button submit options={['green', 'small', 'desktop']}>
          Update
        </Button>

        <Button options={['red', 'small']} element='a' href='/logout'>
          Logout
        </Button>
      </div>
    </header>

    <fieldset>
      <Input label='Login Email' type='email' placeholder='email address' readOnly {...props.fields.email} />
      <Input label='New Password' placeholder='password' type='password' {...props.fields.password} />

      {!!props.user.customers.length && <Input
        label='Order Confirmation Emails' note='Separate multiple emails by commas.'
        placeholder='email@example.com'
        {...props.fields.cc_orders}
      />}

      {/*
        No timezones for now..  timezoneOptions comes from helpers/components
        props.isAdmin && <Select
          label='Timezone'
          placeholder='select timezone'
          selectOptions={timezoneOptions}
          clearable={false}
          {...props.fields.timezone}
        />
      */}

      {props.isAdmin && <Select
        label='Rollover to Next Day'
        note='After this time, the customer would default to ordering for the next day.'
        placeholder='select a time'
        selectOptions={rolloverOptions}
        clearable={false}
        {...props.fields.rollover_offset}
      />}
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Update
      </Button>
    </footer>
  </form>
)

Account.propTypes = {
  user: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool
}

export default Account



// WEBPACK FOOTER //
// ./src/components/Users/Account/Account.js